import React, {useEffect} from "react";
import {getApplications} from "../api/applications";
import {message} from "antd";

const Applications: React.FC = () => {

    const [applications, setApplications] = React.useState([]);

    useEffect(() => {
        // Download applications data for current firm
        getApplications()
            .then((data) => {
                console.log('Applications data:', data);
                setApplications(data);
            })
            .catch((error) => {
                console.error('Error fetching dashboard data:', error);
                void message.error(`Erreur lors du chargement des données du tableau de bord ${error.message}`);
            });

    }, []);

    return (
        <div className="Applications">
            <h2>Applications</h2>
            <ul>
                {applications.map((application: any) => (
                    <li key={application.idt}>
                        <h3>{application.name}</h3>
                        <p>{application.description}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Applications;